import { useAccountState } from '../../../redux/reducers/accountReducer';
import { Column, Row } from '../../common';

import { UserAccount } from '../../../data/types';
import { useTaskService } from '../../../data/services';
import { useMediaSizes } from '../../common/Styles/useMediaSizes';
import { appTokens } from '../../common/Styles/appTokens';

export const Dashboard = () => {
    //Hooks
    const { primaryAccount } = useAccountState();
    const { account, user } = (primaryAccount as UserAccount) ?? {};
    const taskService = useTaskService();
    const media = useMediaSizes();

    const getMaxHeight = () => {
        if(!media.isUnderLaptop){
            return 'calc(50vh - 4rem)';
        }
        else return '25rem';
    }

    return (
        <Column flex='1' scroll padding='pt-1 pb-3 px-1' maxHeight={appTokens.pageHeight()}>
            <Row noWrap={!media.isUnderDesktop} gap='large' flexWrap='wrap-reverse'>
                <Column flex={`${media.getSizes('3', '2', '1', '1')} 1 300px`} gap='large' height='auto'>
                    {/* <MyCasesCard maxHeight={getMaxHeight()} />
                    {account?.features?.tasks && (
                        <TasksCard
                            maxHeight={getMaxHeight()}
                            tasks={taskService.tasks.filter((x) => x.userId === user?.userId)}
                            onSubmitTask={taskService.upsertTaskAsync}
                            onComplete={taskService.onComplete}
                            onClose={taskService.onClose}
                        />
                    )} */}
                </Column>
                <Column flex={`${media.getSizes('2', '1', '1', '1')} 1 300px`} gap='large'>
                    {/* {account?.features?.timeTracking && <QuickInsightsCard />}
                    {account?.features?.events && <UpcomingEventsCard />} */}
                </Column>
            </Row>
        </Column>
    );
};
